<template>
  <Layout />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Layout from '@/components/Layout'

export default defineComponent({
  components: {
    Layout
  }
})
</script>

<style lang="scss">
img {
  width: 100% !important;
  height: 100% !important;
}

.content {
  span {
    font-size: 14px !important;
    font-family: Source Han Sans CN;
    font-weight: 320 !important;
    color: #fff !important;
    opacity: 1;
    background: transparent !important;
  }
  a {
    color: #FFB400 !important;
  }
}
</style>
